<script>
  import { tourFunctions } from "../tour-functions";
  import { Preloader } from "./preloader";
  import { fly } from "svelte/transition";
  import i18n from "./i18n/i18n";

  // Tooltips
  import Tooltip from "./Tooltip.svelte";
  let showingTooltip = false;
  const showTooltip = () => {
    showingTooltip = true;
  };
  const hideTooltip = () => {
    showingTooltip = false;
  };

  export let tour;
  export let sceneState;
  const preloader = new Preloader(tour);

  export let prevScene = () => {
    tourFunctions.prevSceneWithOrder(sceneState.currentOrder);
    preloader.preloadCurrentScene();
  };

  export let hideFirst = false;

  let sceneIndex = tourFunctions.currentScene.getIndex();
  addEventListener("krpano:newpano", () => {
    sceneIndex = tourFunctions.currentScene.getIndex();
  });
</script>

{#if !hideFirst || sceneIndex > 0}
  <button
    class="prev"
    on:click={prevScene}
    transition:fly={{ x: -300, duration: 500 }}
    on:mouseenter={showTooltip}
    on:mouseleave={hideTooltip}
    aria-label={$i18n.t('tour.prevScene')}
  >
    <Tooltip text={$i18n.t('tour.prevScene')} {showingTooltip} position={"right"} />
    <div class="icon">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.71 32.59"
        ><polyline
          points="18.68 1.11 2.21 16.18 18.68 31.49"
          style="fill:none;stroke:var(--prev-scene-text-color);stroke-miterlimit:10;stroke-width:2px"
        /></svg
      >
    </div>
  </button>
{/if}

<style>
  :root {
    --prev-scene-bg-color-rgb: var(--theme-color-rgb);
    --prev-scene-text-color: var(--controls-text-color);
  }

  button {
    background: rgba(var(--prev-scene-bg-color-rgb), 0.8);
    color: var(--prev-scene-text-color);
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    z-index: 999;
    border-radius: 0 10px 10px 0;
    cursor: pointer;
    padding: 20px 20px 20px 10px;
    border: none;
  }

  button:hover {
    background: rgba(var(--prev-scene-bg-color-rgb), 1);
    border: 3px solid var(--prev-scene-text-color);
    border-width: 3px 3px 3px 0;
  }

  .icon {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  svg {
    width: 35px;
    height: 35px;
  }
</style>
